module.exports = __webpack_public_path__ + "static/media/dummy.2942bfab.pdf";